import styled from "styled-components";
import Colors from "../../../constants/Colors";

export const GenericSolidButton = styled.button<{color?: string, width?:number, inverted?: boolean}>`
    background-color:${props=>props.color? props.color : props.inverted? '#E0F0F5':Colors.lightBlue};
    display: flex;
    color: ${props=>props.inverted? Colors.SPM600 : 'white'};
    width: ${props=> props.width !== null ? `${props.width}%` : "auto"};
    flex-direction: row;
    font-weight: bold;
    justify-content: center;
    align-items:center;
    padding: 12px 16px;
    gap: 12px;
    border: ${props=>props.inverted? '0px solid #4D638D':'0px solid #4D638D'};
    border-radius:8px;
    font-family: 'Inter', sans-serif;
    letter-spacing: 0.5px;

    &:disabled{
        opacity: 0.5;
    }

    &:hover{
        cursor: ${props=>props.disabled? 'text':'pointer'};
    }

    &:active{
        background-color: ${props=>props.disabled? '':'#D7DDF4'};
        color: ${props=>props.disabled? '':Colors.lightBlue};
        border-color: ${props=>props.disabled? '':'#D7DDF4'};
    }

    @media screen and (max-width: 760px){
        width: 100%;
    }
    
`

export const RedCancelButton = styled.button`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items:center;
    padding: 12px 16px;
    gap: 12px;
    margin-right: 16px;
    background-color: #FEE2E2;
    color:#991B1B;
    border-radius: 8px;
    border:0px solid white;
    font-weight: bold;
    
    font-family: 'Inter', sans-serif;
    letter-spacing: 0.5px;

    &:disabled{
        opacity: 0.5;
    }

    &:hover{
        cursor: ${props=>props.disabled? 'text':'pointer'};
    }

    &:active{
        background-color: ${props=>props.disabled? '':'#ff7a7a'}; 
        color: ${props=>props.disabled? '': 'white'};
    }

    @media screen and (max-width: 760px){
        width: 100%;
        margin-right: 0px;
    }
`

export const BlueEditButton = styled.button`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items:center;
    padding: 12px 16px;
    margin-right: 16px;
    gap: 12px;
    background-color: ${Colors.SPM50};
    color: ${Colors.SPM600};
    border-radius: 8px;
    border:0px solid white;
    font-weight: bold;

    font-family: 'Inter', sans-serif;
    letter-spacing: 0.5px;

    &:disabled{
        opacity: 0.5;
    }

    &:hover{
        cursor: ${props=>props.disabled? 'text':'pointer'};
    }

    
    &:active{
        background-color: ${props=>props.disabled? '':'#a1abd1'};
    }


    @media screen and (max-width: 760px){
        width: 100%;
        margin-right: 0px;
    }
`

export const OutlinedUpdateButton = styled.div<{isMobile: boolean}>`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 12px;
    gap: 8px;
    cursor: pointer;
    color: ${Colors.SPM500};
    font-family: 'Inter', sans-serif;
    width: ${props=>props.isMobile? '95%':'150px'};
    border: 1px solid ${Colors.SPM500};
    border-radius: 8px;
`